import axios from "axios";
import { SERVER_URL } from "../socket";

export async function listClients(headers) {
  const res = await axios.get(`${SERVER_URL}/api/clients`, { headers });
  return Array.isArray(res.data?.clients) ? res.data.clients : [];
}

export async function createClient(payload, headers) {
  const res = await axios.post(`${SERVER_URL}/api/clients`, payload, { headers });
  return res.data?.client || null;
}

export async function updateClient(id, payload, headers) {
  const res = await axios.put(`${SERVER_URL}/api/clients/${id}`, payload, { headers });
  return res.data?.client || null;
}

export async function deleteClient(id, headers) {
  const res = await axios.delete(`${SERVER_URL}/api/clients/${id}`, { headers });
  return res.data || null;
}

export async function uploadClientUsers(clientId, file, headers, password) {
  const form = new FormData();
  form.append("file", file);
  if (password) form.append("password", password);
  const res = await axios.post(`${SERVER_URL}/api/clients/${clientId}/upload-users`, form, {
    headers: {
      ...headers,
    },
  });
  return res.data;
}
